import {
  ActionTypes,
  SearchFlightState,
  dispatch,
  searchFlightStore,
} from "@/core/stores/searchflight.store";
import { Component, Element, Fragment, State, h, Prop } from "@stencil/core";
import { EmissionsBoxComponent } from "./emissions-box";
import { EmptyBoxComponent } from "./empty-box";
import { SeatsBoxComponent } from "./seats-box";
import { theme } from "@/utils/theme";
import { EquivalentsBoxComponent } from "@/components/internal/result/equivalents-box";

@Component({
  tag: "pace-result-box",
  styleUrl: "result-box.scss",
  shadow: false,
})
export class ResultBoxComponent {
  @State() searchFlights: SearchFlightState;
  @Prop() showEquivalents = true;
  @Element() el: HTMLElement;

  methodologyDocument =
    "https://storage.googleapis.com/pace-eu-documents/PACE-PAX-Widget-Methodology.pdf";

  componentWillLoad() {
    searchFlightStore.subscribe((searchFlights) => {
      this.searchFlights = { ...searchFlights };
    });
  }

  render() {
    const results = this.searchFlights.results;
    return (
      <Fragment>
        <section
          class={`results ${theme.getSectionClass(4)}`}
          style={theme.getContentStyle()}
        >
          {this.searchFlights.loading && <div class="cover-spin"></div>}
          {!this.searchFlights.submitted && <EmptyBoxComponent />}
          {this.searchFlights.submitted &&
            !this.searchFlights.displayAircraftDiagram && (
              <EmissionsBoxComponent
                results={results}
                onAircraftTypeClick={() =>
                  dispatch({ type: ActionTypes.SWITCH_RESULTS_TAB })
                }
              />
            )}
          {this.searchFlights.submitted &&
            this.searchFlights.displayAircraftDiagram && (
              <SeatsBoxComponent results={results} />
            )}
        </section>
        {this.showEquivalents && this.searchFlights.submitted && (
          <section
            class={`results--equivalents ${theme.getSectionClass(4)}`}
            style={theme.getContentStyle()}
          >
            <EquivalentsBoxComponent results={results} />
          </section>
        )}
        {this.searchFlights.submitted && (
          <section
            class={"results--methodology"}
            style={theme.getContentSecondaryStyle()}
          >
            <span>
              <a
                style={theme.getLinkStyle()}
                href={this.methodologyDocument}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                Click here
              </a>{" "}
              to find out more about our PACE methodology.
            </span>
          </section>
        )}
      </Fragment>
    );
  }
}
